
import { Component, Vue } from "vue-property-decorator";

@Component
class NavBar extends Vue {
  tab = 0;
  get isAuthenicated(): boolean {
    if (
      this.$store.state.authenication.userData.email &&
      !this.$store.state.authenication.weakPassword
    ) {
      return true;
    }
    return false;
  }
  get isAdmin(): boolean {
    return this.$store.getters["authenication/isAdmin"];
  }
  get getEmail(): string {
    return this.$store.state.authenication.userData.email;
  }

  get isProduction(): boolean {
    if (process.env.VUE_APP_ENVIRONMENT === "production") {
      return true;
    }
    return false;
  }

  get getNavBarClass(): string {
    if (process.env.VUE_APP_ENVIRONMENT === "production") {
      return "";
    } else {
      return "navbar-debug";
    }
  }

  get getVersionDate(): string {
    if (process.env.VUE_APP_VERION_DATE === undefined) {
      return "";
    } else {
      return process.env.VUE_APP_VERION_DATE;
    }
  }
  get isEditing(): boolean {
    if (
      this.$store.state.gameStore.isEditing ||
      this.$store.state.cityStore.isEditing ||
      this.$store.state.gameStore.isGameEditing
    ) {
      return true;
    } else {
      return false;
    }
  }

  get getNavBarPinkClass(): string {
    if (process.env.VUE_APP_ENVIRONMENT === "production") {
      return "navbar-brand-pink";
    } else {
      return "navbar-brand-pink-debug";
    }
  }

  get version(): string {
    if (process.env.VUE_APP_ENVIRONMENT === "production") {
      return "Live";
    } else if (process.env.VUE_APP_ENVIRONMENT === "staging") {
      return "Staging";
    } else {
      return "Dev";
    }
  }
  get getNavTab(): number {
    return this.$store.getters["authenication/getNavTab"];
  }

  updateTab(tab: number) {
    this.$store.commit("authenication/setNavTab", tab);
  }

  logoutUser(): void {
    this.$store.dispatch("authenication/userLogoutAsync");
  }
}

export default NavBar;
